import { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useLocalizedPath } from '@/lib/i18n';

/**
 * Drop-in replacement for react-router-dom <Link> that prefixes internal `to`
 * with `/en` when the current language is English. External URLs and hash
 * links pass through unchanged.
 */
export const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps>(
  function LocalizedLink({ to, ...rest }, ref) {
    const localize = useLocalizedPath();
    const localized = typeof to === 'string' ? localize(to) : to;
    return <Link ref={ref} to={localized} {...rest} />;
  },
);